import { createMuiTheme } from '@material-ui/core/styles'

const BORDER_COLOR = '#c6d2d9'
const theme = createMuiTheme({
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  palette: {
    primary: {
      main: '#666',
      contrastText: '#fff'
    },
    secondary: {
      main: '#03a9f4', //'#f44336'
      contrastText: '#fff'
    }
  },
  backgroundColor: '#f2f6f8',
  sideBar: {
    normal: '#000',
    active: '#000',
    hoverBackground: '#e4eaee',//'#128EDC',
    hoverColor: '#000',
    activeHoverColor: '#000',
    backgroundColor: '#fff'
  },
  borderColor: BORDER_COLOR,
  card: {
    border: `1px solid ${BORDER_COLOR}`,
    borderBottomWidth: 4,
    header: {
      color: '#999',
      backgroundColor: '#e4eaee',
      fontWeight: 300
    }
  },
  grid: {
    withoutFilter: {
      backgroundColor: '#f2f6f8'
    },
    activeFilter: {
      backgroundColor: '#feffe8'
    },
    filteredColumn: {
      backgroundColor: '#e1f5fe'
    },
    alternativeRow: {
      backgroundColor: '#f2f6f800'
    }
  }
})

export {
  theme
}
